import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from '@Log/shared';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

import { getServiceNameByValue } from '@Utils/service';
import { formatTableServices, sortTableDataByService } from '@Utils/table';

import { ThreatType } from '@Utils/enums';
import Percent from '@Dashboard/Charts/Percent';
import TableTemplate from '@Dashboard/Charts/TableTemplate';
import DashboardCard from '@Dashboard/Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';

function SummaryAtpRisk(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '12%', grow: 1, align: 'right' },
    { width: '12%', grow: 1, align: 'right' },
    { width: '10%', grow: 1, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.service'),
    t(`dashboard.chart.column.last${props.day}`),
    t(`dashboard.chart.column.prev${props.day}`),
    t('dashboard.chart.column.change'),
  ];

  const rawData = formatTableServices(
    props.data?.summaryAdvancedThreatProtection?.[props.day],
    props.data?.summaryAdvancedThreatProtectionPrevious?.[props.day],
    servicesModel.services
  );
  const data = sortTableDataByService(rawData).map((row) => [
    t(`common.service.${row[0]}`),
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'threatType',
              values: [
                ThreatType.Phishing,
                ThreatType.BEC,
                ThreatType.Spoofing,
                ThreatType.MaliciousFile,
                ThreatType.MaliciousURL,
                ThreatType.Spam,
                ThreatType.Ransomware,
              ],
              type: 'terms',
            },
            {
              field: 'securityFilterName',
              values: [
                SecurityFilterName.AdvancedSpamProtection,
                SecurityFilterName.MalwareScanning,
                SecurityFilterName.VirtualAnalyzer,
                SecurityFilterName.WebReputation,
                SecurityFilterName.FileBlocking,
              ],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: [getServiceNameByValue(row[0])],
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    <Percent n={row[row.length - 1]} />,
  ]);

  return (
    <DashboardCard height="540px" title={t('dashboard.chart.title.atpSummary')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SummaryAtpRisk);
